import courseStudentsAPI from '../../api/courseStudentsAPI'

const state = {
  course_id: null,
  students: null,
}

const mutations = {
  set_course(state, course_id){
    state.course_id = course_id
  },
  set_students(state, students){
    state.students = students
  },
  add_student(state, student){
    state.students[student.group].push(student.data)
  },
  remove_student(state, student){
    state.students[student.group].splice(state.students.indexOf(student.data), 1)
  },
  approve_student(state, {student, group, status}){
    state.students[group].find(s => s.id === student.id).is_approved = status
  },
  empty_student_group(state, {group}) {
    state.students[group] = []
  }
}

const actions = {
  loadStudents({commit}, course_id){
    return new Promise((resolve, reject) => {
      courseStudentsAPI.setCourseId(course_id)
      // if(state.students && state.course_id === course_id){
      //   resolve(state.students)
      //   return
      // }
      courseStudentsAPI.getAll()
        .then(response => {
          commit('set_course', course_id)
          commit('set_students', response.data.groups)
          resolve(response.data.groups)
        })
        .catch(error => reject(error))
    })
  }
}

const getters = {
  getGroupsOfStudents(state){
    return state.students
  },
  courseId(state){
    return state.course_id
  }
}

export default({
  namespaced: true,
  state,
  getters,
  actions,
  mutations
});
